/* ========================================================================== *\
   SWM FORM
\* ========================================================================== */

function swmForm() {
  const swmForm = document.querySelectorAll(".swm-form");

  swmForm.forEach((form) => {
    const endpoint = form.dataset.swmEndpoint;

    form.addEventListener("submit", (e) => {
      e.preventDefault();

      //Don't submit form again if submit is in progress
      const isSubmittingClass = "is-submitting";
      if (!form.classList.contains(isSubmittingClass)) {
        submitForm();
      }

      //Remove old alert(s)
      function removeAlerts() {
        const hasAlert = form.querySelectorAll(".swm-alert-container");
        if (hasAlert) {
          hasAlert.forEach((alert) => {
            Animation.slideUp(alert, () => {
              alert.remove();
            });
          });
        }
      }

      //Create and insert alert
      function handleAlert(success, message) {
        const alertContainer = document.createElement("div");
        alertContainer.classList.add("swm-alert-container");
        alertContainer.setAttribute(
          "style",
          "height: 0; margin-bottom: 12px; overflow: hidden; transition: height .25s ease-in-out;",
        );
        alertContainer.setAttribute("role", "alert");

        const alert = document.createElement("p");
        alert.classList.add("alert");

        if (success) {
          alert.classList.add("alert--success");
          alert.textContent = message ? message : "Success";
        } else {
          alert.classList.add("alert--error");
          alert.textContent = message ? message : "Error";
        }

        alertContainer.append(alert);

        form.prepend(alertContainer);
        Animation.slideDown(alertContainer);
      }

      //Handle submit
      function submitForm() {
        removeAlerts();

        grecaptcha.enterprise.ready(() => {
          (async () => {
            document.dispatchEvent(new CustomEvent("theme:loading:start"));
            form.classList.add(isSubmittingClass);

            try {
              const token = await grecaptcha.enterprise.execute(
                "6LemwGYrAAAAAOeSi5IDWlzHlKF0t1RzX3Q8c_-n",
                {
                  action: "submit",
                },
              );

              const formData = new FormData(form);
              const data = Object.fromEntries(formData.entries());
              data.token = token;

              const res = await fetch(endpoint, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(data),
              });

              const json = await res.json();

              if (json.ok) {
                handleAlert(true, json.message);
              } else {
                handleAlert(false, json.message);
              }
            } catch (error) {
              handleAlert(
                false,
                "Sorry, we’re currently having submitting this form. Please check your information and try again.",
              );
            } finally {
              document.dispatchEvent(new CustomEvent("theme:loading:end"));
              form.classList.remove(isSubmittingClass);
            }
          })();
        });
      }
    });
  });
}

swmForm();
